export const departmentList = {
  cardiology_and_cardiac_surgery: 'Cardiology',
  cosmetic_and_plastic_surgery: 'Cosmetic',
  dental_treatment: 'Dental',
  dermatology: 'Dermatology',
  endocrinology: 'Endocrinology',
  ent_surgery: 'Ent surgery',
  gastroenterology: 'Gastroenterology',
  general_surgery: 'General surgery',
  gynecology: 'Gynecology',
  hair_treatment: 'Hair treatment',
  hematology: 'Hematology',
  hepatology: 'Hepatology',
  ivf_and_infertility: 'IVF',
  nephrology: 'Nephrology',
  neurology_and_neurosurgery: 'Neurosurgery',
  obesity_or_bariatric_surgery: 'Bariatric',
  oncology_and_oncosurgery: 'Oncology',
  opthalmology: 'Opthalmology',
  orthopedics: 'Orthopedics',
  pediatric_cardiology: 'Ped. Cardio',
  pediatrics_and_pediatric_surgery: 'Pediatrics',
  pulmonology: 'Pulmonology',
  rheumatology: 'Rheumatology',
  spine_surgery: 'Spine surgery',
  transplant_surgery: 'Transplant surgery',
  urology_treatment: 'Urology',
  vascular_surgery: 'Vascular'
};
